<template>
  <v-container>
    <v-card class="pa-16">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field class="widthsizesearch" v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details outlined dense></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end mb-6">
          <v-btn class="mr-2" @click="showsearchmore">
            Filter
            <v-icon right>{{ seticonsearchmore.icon }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <br />
      <v-row v-show="toggleEnable">
        <v-col cols="12" md="5"> </v-col>
        <v-col align="right" cols="12" xl="1" lg="1" md="1"></v-col>

        <v-col cols="12" xl="3" lg="3" md="3">
          <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="datefrom" label="DateFrom" append-icon="mdi-calendar" readonly v-bind="attrs"
                v-on="on" outlined dense clearable @click:clear="
                  $nextTick(() => {
                    datefrom = null;
                    dateto = null;
                  })
                  " @input="finddatafromdate"></v-text-field>
            </template>
            <v-date-picker v-model="datefrom" @input="menu = false" @change="finddatafromdate"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" xl="3" lg="3" md="3">
          <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateto" label="DateTo" append-icon="mdi-calendar" readonly outlined dense
                v-bind="attrs" v-on="on" clearable @click:clear="
                  $nextTick(() => {
                    datefrom = null;
                    dateto = null;
                  })
                  " @input="finddatafromdate"></v-text-field>
            </template>
            <v-date-picker v-model="dateto" @input="menu2 = false" @change="finddatafromdate"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <template>
        <v-data-table :search="search" :headers="headers" :items="mDataArray" class="elevation-1 595959" show-select
          v-model="selected" item-key="id" @input="enterSelect($event)">
          <template v-slot:item.data-table-select="{ item, isSelected, select }">
            <v-simple-checkbox :value="isSelected" :readonly="item.disabled" :disabled="item.disabled"
              @input="select($event)"></v-simple-checkbox>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
              Reset
            </v-btn>
          </template>
        </v-data-table>
      </template>
      <br />
      <br />
      <template>
        <v-row justify="center">
          <v-dialog v-model="dialogConfirm" fullscreen hide-overlay transition="dialog-bottom-transition"
            @keydown.esc="closedialogConfirm()">
            <v-card>
              <v-toolbar dark color="#4169e1">
                <v-toolbar-title>Invoice: TimeSheet</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn icon dark @click="closedialogConfirm()">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-list three-line subheader class="pa-16">
                <v-title class="text-h5">TimeSheets Details</v-title>
                <v-list-item>
                  <v-list-item-content>
                    <v-data-table :headers="headersC" :items="mDataArrayC" class="elevation-1 595959"></v-data-table>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-list three-line subheader>
                <v-title class="text-h5">
                  <v-row>
                    <v-col cols="12" md="8" offset="2">Timekeeper Details</v-col>
                  </v-row>
                </v-title>
                <v-list-item class="pl-7">
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12" md="8" offset="2">
                        <v-data-table :headers="headerstc" :items="mDataArraytc" class="elevation-1 595959">
                          <template v-slot:item.tc_rate_show="{ item }">
                            <v-text-field type="number" v-model="item.tc_rate_show" multi-line dense auto-grow
                              class="pt-3" @blur="Calculate(item)"></v-text-field>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12" md="8" offset="2">
                        <v-row justify="end">
                          <v-col cols="12" md="11" order-md="1">
                            <v-row justify="end">
                              <v-col cols="12" md="2">
                                <v-text-field v-model="sum_chargehour_show" type="text" reverse outlined dense
                                  background-color="#F5F5F5" disabled>
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field v-model="sum_rateChargehour_show" type="text" reverse outlined dense
                                  background-color="#F5F5F5" disabled>
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field v-model="sum_noCharge_hour_show" type="text" reverse outlined dense
                                  background-color="#F5F5F5" disabled>
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field v-model="sum_noCharge_bath_show" type="text" reverse outlined dense
                                  background-color="#F5F5F5" disabled>
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row justify="end">
                              <v-col justify="end" cols="12" md="2" class="text-h5">
                                <span>Grand Total </span>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field v-model="sum_grandTotal_show" type="text" reverse outlined dense
                                  background-color="#F5F5F5" disabled>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <v-row justify="center">
        <v-btn :disabled="disableinstatus" @click="opendialogConfirm()" color="#0A7EA5" rounded dark class="mb-2">
          Confirm
        </v-btn>
      </v-row>
      <br />
      <br />
    </v-card>

    <SuccessDialogInvoice_Mis :status="dialogAddMis" :text_color="text_colorMis" :title="titleMis"
      :message="messageMis" />
  </v-container>
</template>

<script>
import SuccessDialogInvoice_Mis from "@/components/cards/SuccessDialogInvoice_Mis";
import SuccessDialog from "@/components/cards/SuccessDialog";
import invoiceTimeSheetTap_Selet from "./invoiceTimeSheetTap_Selet";
import api from "@/services/api";
import { server } from "@/services/constants";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";

export default {
  props: [
    "disableinstatus",
    "ts_status_oper",
    "tsTAB_IdforCus",
    "ts_idTab",
    "getdataByCusStatus",
    "selected_showE",
    "oper_sel",
    "cus_invts",
    "mode_oper_ts"
  ],
  // mounted() {
  //   // this.$showLoader();
  //   setTimeout(() => {
  //     this.$hideLoader();
  //   }, 500);
  // },
  components: {
    SuccessDialog,
    invoiceTimeSheetTap_Selet,
    SuccessDialogInvoice_Mis,
  },
  data(vm) {
    return {
      dialogAddMis: false,
      text_colorMis: "text-h5 green--text text-center",
      titleMis: "green",
      messageMis: "green",
      isShowPassword: false,
      fullPage: true,
      toggleEnable: false,
      mDataArray: [],
      selected: [],

      search: "",
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      menu: false,
      menu2: false,
      datefrom: null,
      dateto: null,
      dialogConfirm: false,
      headers: [
        {
          text: "TimeSheet No.",

          class: "bg-colorth texttablehcenter ",
          value: "timesheet_id",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Requested Date",
          value: "date",
          class: "bg-colorth texttablehcenter",

          align: "start",
          divider: true,
          sortable: false,
          width: "105px",
        },

        {
          text: "TimeSheet Name",
          class: "bg-colorth texttablehcenter",
          value: "timesheet_name",
          divider: true,
          align: "start",
          sortable: false,
        },
        {
          text: "Client",
          class: "bg-colorth texttablehcenter",
          value: "cus_name",
          divider: true,
          align: "start",
          sortable: false,
        },
        {
          text: "Employee",
          class: "bg-colorth texttablehcenter",
          value: "emp_name",
          divider: true,
          align: "start",
          sortable: false,
        },
        {
          text: "Total(Hours)",

          class: "bg-colorth texttablehcenter",
          value: "total_show",
          divider: true,
          align: "center",
          sortable: false,
        },

        {
          text: "Status",
          class: "bg-colorth texttablehcenter",
          align: "center",
          value: "status",
          divider: true,
          sortable: false,
        },
      ],
      mDataArrayC: [],
      dataAllC: [],
      timesheet_hid: [],
      hid_array: {},
      headersC: [
        {
          text: "Date",

          class: "bg-colorth texttablehcenter ",
          value: "date",
          align: "start",
          divider: true,
          sortable: false,
          width: "110px",
        },
        {
          text: "Assignment",
          value: "job_name",
          class: "bg-colorth texttablehcenter",
          width: "17%",
          align: "start",
          divider: true,
          sortable: false,
        },

        {
          text: "Employee",
          class: "bg-colorth texttablehcenter",
          value: "emp_name",
          divider: true,
          align: "start",
          sortable: false,
          width: "20%",
        },
        {
          text: "Work Hour",
          value: "show_hours",
          class: "bg-colorth texttablehcenter",

          divider: true,
          align: "center",
          sortable: false,
          width: "140px",
        },
        {
          text: "Charge Hour",
          value: "show_chargehour",
          class: "bg-colorth texttablehcenter",

          divider: true,
          align: "center ",
          sortable: false,
          width: "140px",
        },

        {
          text: "Details",
          class: "bg-colorth texttablehcenter",
          align: "start",
          value: "detail",
          divider: true,
          sortable: false,
        },
      ],
      mDataArraytc: [],
      dataAlltc: [],
      headerstc: [
        {
          text: "Timekeepers",

          class: "bg-colorth texttablehcenter ",
          value: "tc_name",
          align: "start",
          divider: true,
          sortable: false,
          width: "23%",
        },
        {
          text: "Rate(Baht)",
          value: "tc_rate_show",
          class: "bg-colorth texttablehcenter",
          width: "16%",
          align: "end",
          divider: true,
          sortable: false,
        },

        {
          text: "Charge Hours",
          class: "bg-colorth texttablehcenter",
          value: "tc_actualchargehour_show",
          divider: true,
          align: "end",
          sortable: false,
          width: "15%",
        },
        {
          text: "Charge Value(Baht)",
          value: "tc_rateChargeHour_bath_show",
          class: "bg-colorth texttablehcenter",

          divider: true,
          align: "end",
          sortable: false,
          width: "16%",
        },
        {
          text: "No Charge Hours",
          value: "tc_nocharge_show",
          class: "bg-colorth texttablehcenter",

          divider: true,
          align: "end ",
          sortable: false,
          width: "15%",
        },

        {
          text: "No Charge Value (Baht)",
          class: "bg-colorth texttablehcenter",
          align: "center",
          value: "tc_nochargeCal_show",
          divider: true,
          sortable: false,
          width: "15%",
        },
      ],
      sum_chargehour: 0,
      sum_rateChargehour: 0,
      sum_noCharge_hour: 0,
      sum_noCharge_bath: 0,
      sum_grandTotal: 0,
      sum_chargehour_show: 0,
      sum_rateChargehour_show: 0,
      sum_noCharge_hour_show: 0,
      sum_noCharge_bath_show: 0,
      sum_grandTotal_show: 0,
      getlist_tsid: {},
      cusid_ts: 0,
      inv_ts_list: []
    };
  },
  async mounted() {
    await this.loaddataAdvance();
  },
  methods: {
    async Calculate(data) {
      let rateCH = 0;
      rateCH = Number(data.tc_rate_show) * stringcommatonumber(data.tc_actualchargehour_show)
      data.tc_rate = data.tc_rate_show;
      data.tc_rate_show = data.tc_rate_show;
      data.tc_rateChargeHour_bath_show = tolocalestringnumber(rateCH);
      data.tc_rateChargeHour_bath = String(rateCH);

      let editedIndex = -1;
      editedIndex = this.mDataArraytc.indexOf(data);
      let data_set = [];
      let inx_dataset = 0;
      this.mDataArraytc.forEach((item, index) => {
        if (editedIndex == index) {
          data_set[inx_dataset] = data
        } else {
          data_set[inx_dataset] = item;
        }
        inx_dataset += 1;
      })
      this.mDataArraytc = data_set;
      let sumCH = 0;
      this.mDataArraytc.forEach((item, index) => {
        sumCH += Number(item.tc_rateChargeHour_bath);
      })
      this.sum_rateChargehour_show = tolocalestringnumber(sumCH);
      this.sum_grandTotal_show = tolocalestringnumber(sumCH);
      this.sum_grandTotal = sumCH;
      this.inv_ts_list = this.mDataArraytc;
    },
    showsearchmore() {
      this.toggleEnable = !this.toggleEnable;
      this.seticonsearchmore.action = !this.seticonsearchmore.action;
      if (this.seticonsearchmore.action === true) {
        this.seticonsearchmore.icon = "mdi mdi-chevron-up";
      } else {
        this.seticonsearchmore.icon = "mdi mdi-chevron-down";
      }
    },
    async loaddataAdvance() {
      this.$showLoader();
      // alert(this.getdataByCusStatus)
      // alert(this.tsTAB_IdforCus)
      if (this.getdataByCusStatus == "INV") {
        const res_cusid = await api.billing_expense_getdataByIdInvoice_H(this.tsTAB_IdforCus);
        // console.log(res_cusid.data[0].customer_id)
        if (res_cusid.data[0]) {
          this.cusid_ts = res_cusid.data[0].customer_id;
        }
      } else {
        const res_cusid = await api.getCusId(this.tsTAB_IdforCus);
        // console.log(res_cusid.data[0].customer_id)
        if (res_cusid.data[0]) {
          this.cusid_ts = res_cusid.data[0].customer_id;
        }
      }
      if (this.ts_status_oper == "Submit") {
        this.getlist_tsid.ts_id = this.ts_idTab;
        console.log("lenth:" + this.getlist_tsid.ts_id.length);

        if (this.getlist_tsid.ts_id.length > 0) {
          const result = await api.getByemptimesheetHS(this.getlist_tsid);
          this.dataAll = result.data;
          this.dataAll.forEach((item) => {
            let hours = Math.floor(Number(item.total) / 60);
            let mins = Number(item.total) - hours * 60;
            item.total_show = hours + " ชั่วโมง " + mins + " นาที";
            item.disabled = true;
          });
          this.mDataArray = this.dataAll;
          this.selected = this.mDataArray;
        } else {
          this.mDataArray = this.dataAll;
          this.selected = this.mDataArray;
        }
      } else {
        // alert(this.oper_sel)
        const result = await api.billing_expense_getByemptimesheetHV2(this.cusid_ts);
        this.dataAll = result.data;
        if (this.oper_sel == 1) {
          let indexS = 0;
          this.dataAll.forEach((item, index, object) => {
            let hours = Math.floor(Number(item.total) / 60);
            let mins = Number(item.total) - hours * 60;
            item.total_show = hours + " ชั่วโมง " + mins + " นาที";
            for (let i = 0; i < this.ts_idTab.length; i++) {
              if (item.id == this.ts_idTab[i]) {
                this.selected_showE[indexS] = item;
                indexS += 1;
              }
            }
          });
          this.mDataArray = this.selected_showE.concat(this.dataAll);
          this.mDataArray = [...new Set(this.mDataArray)];
          this.selected = this.selected_showE;
          this.oper_sel = 0;
        } else {
          this.dataAll.forEach((item, index, object) => {
            let hours = Math.floor(Number(item.total) / 60);
            let mins = Number(item.total) - hours * 60;
            item.total_show = hours + " ชั่วโมง " + mins + " นาที";
          });
          for (let i = 0; i < this.selected_showE.length; i++) {
            this.dataAll.forEach((item, index) => {
              if (this.selected_showE[i].id == item.id) {
                this.dataAll.splice(index, 1);
              }
            });
          }
          this.mDataArray = this.selected_showE.concat(this.dataAll);
          this.selected = this.selected_showE;
        }
      }
      this.$hideLoader();
    },
    enterSelect(values) {
      // console.log(this.selected)
      if (this.ts_status_oper == "Submit") {
        this.disableinstatus = true;
      } else {
        this.disableinstatus = false;
      }
    },
    async closedialogConfirm() {
      this.$emit("getdatafromTStotal", this.sum_grandTotal);
      this.$emit("getTsIdTab", this.hid_array.hid);
      this.$emit("getSelected_showETab", this.selected_showE);
      this.$emit("getOper_selTab", this.oper_sel);
      this.$emit("getInvTsListTab", this.inv_ts_list);
      this.$emit("getmode_oper_tsTab", this.mode_oper_ts);
      this.sum_chargehour = 0;
      this.sum_rateChargehour = 0;
      this.sum_noCharge_hour = 0;
      this.sum_noCharge_bath = 0;
      this.sum_grandTotal = 0;
      this.sum_chargehour_show = 0;
      this.sum_rateChargehour_show = 0;
      this.sum_noCharge_hour_show = 0;
      this.sum_grandsum_noCharge_bath_showTotal = 0;
      this.sum_grandTotal_show = 0;
      this.disableinstatus = true;
      this.dialogConfirm = false;
    },
    async opendialogConfirm() {
      if (this.selected.length > 0) {
        this.selected_showE = this.selected;
        this.timesheet_hid = [];
        for (let i = 0; i < this.selected.length; i++) {
          this.timesheet_hid[i] = this.selected[i].id;
        }
        this.hid_array.hid = this.timesheet_hid;

        this.$showLoader();
        //thimesheet detail
        const resultc = await api.billing_expense_getAllBytimesheet_hid(this.hid_array);
        this.dataAllC = resultc.data;
        this.dataAllC.forEach((item) => {
          let dayH = Math.floor(item.hours / 60);
          let dayM = item.hours % 60;

          item.show_hours = dayH + ` ชั่วโมง ` + dayM + ` นาที`;
          let daycH = Math.floor(item.chargehour / 60);
          let daycM = item.chargehour % 60;

          item.show_chargehour = daycH + ` ชั่วโมง ` + daycM + ` นาที`;
        });
        this.mDataArrayC = this.dataAllC;

        //timesheetCreeper
        const resultcp = await api.billing_expense_getAllBytimesheetCreeper_hid(this.hid_array);
        this.dataAlltc = resultcp.data;
        this.dataAlltc.forEach((item) => {
          item.tc_rateChargeHour_bath = (
            (Number(item.tc_actualchargehour) / 60) *
            Number(item.tc_rate)
          ).toFixed(2);
          item.tc_nocharge = Math.abs(
            (
              (Number(item.tc_actualchargehour) - Number(item.tc_hours)) /
              60
            ).toFixed(2)
          );
          item.tc_nochargeCal = (
            Math.abs(
              (Number(item.tc_actualchargehour) - Number(item.tc_hours)) / 60
            ) * Number(item.tc_rate)
          ).toFixed(2);

          //sum all
          this.sum_chargehour =
            this.sum_chargehour + Number(item.tc_actualchargehour / 60);
          this.sum_rateChargehour =
            this.sum_rateChargehour + Number(item.tc_rateChargeHour_bath);
          this.sum_noCharge_hour =
            this.sum_noCharge_hour + Number(item.tc_nocharge);
          this.sum_noCharge_bath =
            this.sum_noCharge_bath + Number(item.tc_nochargeCal);
          this.sum_grandTotal = this.sum_rateChargehour;

          // //show data in table
          item.tc_rate_show = item.tc_rate;
          item.tc_actualchargehour_show = tolocalestringnumber(
            Number(item.tc_actualchargehour / 60).toFixed(2)
          );
          item.tc_rateChargeHour_bath_show = tolocalestringnumber(
            item.tc_rateChargeHour_bath
          );
          item.tc_nocharge_show = tolocalestringnumber(item.tc_nocharge);
          item.tc_nochargeCal_show = tolocalestringnumber(item.tc_nochargeCal);
        });

        if (this.mode_oper_ts == "edit") {
          // alert(this.mode_oper_ts)
          const res_tnv_ts = await api.billing_expense_getInvTSByID(this.tsTAB_IdforCus)
          let data_invTS = res_tnv_ts.data;
          let dataAll_invTS = this.dataAlltc;
          dataAll_invTS.forEach((item) => {
            for (let i = 0; i < data_invTS.length; i++) {
              if (item.emp_id == data_invTS[i].user_id) {
                item.tc_rate = data_invTS[i].emp_rate;
                item.tc_rate_show = data_invTS[i].emp_rate;
              }
            }
          })
          this.cus_invts = dataAll_invTS;
          this.mode_oper_ts = "add"
        }

        if (this.cus_invts.length > 0) {
          this.sum_rateChargehour = 0;
          this.dataAlltc.forEach((item) => {
            for (let i = 0; i < this.cus_invts.length; i++) {
              if (item.emp_id == this.cus_invts[i].emp_id) {
                item.tc_rate = this.cus_invts[i].tc_rate;
                item.tc_rate_show = this.cus_invts[i].tc_rate_show;
                item.tc_rateChargeHour_bath = item.tc_actualchargehour_show * item.tc_rate;
                item.tc_rateChargeHour_bath_show = tolocalestringnumber(item.tc_rateChargeHour_bath)
              }
            }
          })
          this.dataAlltc.forEach((item) => {

            this.sum_rateChargehour += Number(item.tc_rateChargeHour_bath)
          })
          this.sum_grandTotal = this.sum_rateChargehour
          this.inv_ts_list = this.dataAlltc;
        }
        this.sum_chargehour_show = tolocalestringnumber(this.sum_chargehour);
        this.sum_rateChargehour_show = tolocalestringnumber(
          this.sum_rateChargehour
        );
        this.sum_noCharge_hour_show = tolocalestringnumber(
          this.sum_noCharge_hour
        );
        this.sum_noCharge_bath_show = tolocalestringnumber(
          this.sum_noCharge_bath
        );
        this.sum_grandTotal_show = tolocalestringnumber(this.sum_grandTotal);
        this.mDataArraytc = this.dataAlltc;
        if (this.cus_invts.length == 0) {
          this.inv_ts_list = this.dataAlltc;
        }
        this.$hideLoader();
        this.dialogConfirm = true;
      } else {

        this.sum_chargehour = 0;
        this.sum_rateChargehour = 0;
        this.sum_noCharge_hour = 0;
        this.sum_noCharge_bath = 0;
        this.sum_grandTotal = 0;
        this.sum_chargehour_show = 0;
        this.sum_rateChargehour_show = 0;
        this.sum_noCharge_hour_show = 0;
        this.sum_grandsum_noCharge_bath_showTotal = 0;
        this.sum_grandTotal_show = 0;
        this.hid_array.hid = [];
        this.selected_showE = [];
        this.inv_ts_list = [];
        this.$emit("getdatafromTStotal", this.sum_grandTotal);
        this.$emit("getTsIdTab", this.hid_array.hid);
        this.$emit("getSelected_showETab", this.selected_showE);
        this.$emit("getOper_selTab", this.oper_sel);
        this.$emit("getInvTsListTab", this.inv_ts_list);
        this.$emit("getmode_oper_tsTab", this.mode_oper_ts);
        this.disableinstatus = true;
        this.dialogConfirm = false;
        this.$store.state.global_dialog_invoice_mis = true;
        this.setupAlertDialog(
          true,
          "Information Clear",
          "Information Clear Sucess",
          "text-h5 green--text text-center"
        );

        return;
      }
    },
    finddatafromdate() {
      //alert(this.datefrom)
      this.mDataArray = this.dataAll.filter((item) => {
        if (this.datefrom != null && this.dateto != null) {
          if (item.date >= this.datefrom && item.date <= this.dateto) {
            return item;
          }
        }
        if (this.datefrom == null && this.dateto == null) {
          return item;
        }
      });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month - 1}-${day}`;
    },
    setupAlertDialog(status, titleMis, messageMis, text_colorMis) {
      this.titleMis = titleMis;
      this.messageMis = messageMis;
      this.dialogAddMis = status;
      this.text_colorMis = text_colorMis;
    },
    // setupAlertDialog(status, title, message, text_color) {
    // this.title = title;
    // this.message = message;
    // this.dialogAdd = status;
    // this.text_color = text_color;
    // },
    // setupAlertDialogPush(status, title, message, text_color, link) {
    //   this.title = title;
    //   this.message = message;
    //   this.dialogAdd = status;
    //   this.text_color = text_color;
    //   this.link = link;
    // },
  },
  beforeCreate() {
    // console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>

<style>
.widthsizesearch {
  width: 100%;
}
</style>
